import React from 'react'
import { useTranslation } from 'react-i18next'

export type PromptFormTab = 'basic' | 'advanced'

type PromptFormTabsProps = {
  activeTab: PromptFormTab
  onTabChange: (tab: PromptFormTab) => void
}

export const PromptFormTabs: React.FC<PromptFormTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation()

  const tabs: { id: PromptFormTab; title: string; subtitle: string }[] = [
    {
      id: 'basic',
      title: t('prompts.form.tabs.basic.title'),
      subtitle: t('prompts.form.tabs.basic.subtitle'),
    },
    {
      id: 'advanced',
      title: t('prompts.form.tabs.advanced.title'),
      subtitle: t('prompts.form.tabs.advanced.subtitle'),
    },
  ]

  return (
    <div
      className="prompt-form-tabs"
      role="tablist"
      aria-label={t('prompts.form.tabs.ariaLabel')}
    >
      {tabs.map((tab, index) => {
        const isActive = activeTab === tab.id

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`prompt-form-tab ${isActive ? 'prompt-form-tab-active' : ''} ${index > 0 ? 'prompt-form-tab-separated' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="prompt-form-tab-title">{tab.title}</span>
            <span className="prompt-form-tab-subtitle">{tab.subtitle}</span>
          </button>
        )
      })}
    </div>
  )
}
